import React from 'react'
import './Header.css'
import logo from '../../assets/pngwing.png'

const Header = () => {
  return (
    <div className="header">
    <div className="logo">
        <img src={logo}/>
    </div>
    <div className="menu ">
        <ul>
            <li className='active'>Home</li>
            <li>About Us</li>
            <li>Trainers</li>
            <li>Gallery</li>
            <li>Blog</li>
            <li>Contact</li>
        </ul>
    </div>
    <div className="cnx">
        <ul>
            <li>Log in</li>
            <li>Sign up</li>
        </ul>
    </div>
    </div>
  )
}

export default Header